let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lLpfP")).then(() => parcelRequire('crvL4'));